import { fetchWithAuth } from "../api/client";
import { EmptyResponse, Entity, ErrorResponse } from "../types";

export async function getEntities(token: string): Promise<Entity[]> {
  const res = await fetchWithAuth("Organization", {
    method: "GET",
    token,
  });

  if (!res.ok) {
    throw new Error(`Error fetching entities: ${res.statusText}`);
  }

  return await res.json();
}

export async function createEntity(
  data: Omit<Entity, "id" | "createdAt" | "userCount">,
  token: string
): Promise<Entity | ErrorResponse> {
  const payload = {
    name: data.name,
    contactEmail: data.email,
    description: data.description,
    phone: data.phone,
    address: data.address,
    status: data.status,
  };

  const res = await fetchWithAuth("Organization", {
    method: "POST",
    token,
    body: JSON.stringify(payload),
  });

  if (!res.ok) {
    return {
      error: res.status,
      message: `Error creating entity: ${res.statusText}`,
    };
  }

  return await res.json();
}

export async function updateEntity(
  id: string,
  data: Omit<Entity, "createdAt" | "userCount">,
  token: string
): Promise<EmptyResponse | ErrorResponse> {
  const payload = {
    name: data.name,
    contactEmail: data.email,
    description: data.description,
    phone: data.phone,
    address: data.address,
    status: data.status,
    id: id,
  };

  const res = await fetchWithAuth(`Organization/${id}`, {
    method: "PUT",
    token,
    body: JSON.stringify(payload),
  });

  if (!res.ok) {
    return {
      error: res.status,
      message: `Error updating entity: ${res.statusText}`,
    };
  }

  const text = await res.text();
  return { ok: res.ok, message: text || "Entity updated successfully" };
}

export async function deleteEntity(entityToDelete: Entity, token: string) {
  const res = await fetchWithAuth(`Organization/${entityToDelete.id}`, {
    method: "DELETE",
    token,
  });

  if (!res.ok) {
    return {
      error: res.status,
      message: `Error deleting entity: ${res.statusText}`,
    };
  }

  return { ok: true };
}
